import React, { useEffect } from "react";
import { withTranslation } from "react-i18next";
import styles from "../../accountOwner/pages/OfficeStaffInformation/OfficeStaffInformation.module.scss";
const Page = ({
  isTitleLoading,
  titleKey,
  title,
  onBack,
  actionButton,
  className,
  t,
  children,
  hideBackButton,
  dynamicClassForTitle,
  scrollToTopOnMount = true,
}) => {
  useEffect(() => {
    if (scrollToTopOnMount) window.scrollTo({ top: 0 });
  }, [scrollToTopOnMount]);
  let backButton = null;
  if (onBack) {
    backButton = (
      <button className="back-btn" onClick={onBack}>
        <div className="back-btn-text">
          <span className="ico">
            <img
              src={require("assets/images/arrow-back-icon.svg").default}
              alt="arrow"
            />
          </span>
          {t("back")}
        </div>
      </button>
    );
  }

  return (
    <div className={`page ${className ? className : ""}`}>
      <div className="container">
        {hideBackButton ? null : backButton}

        <Title
          isLoading={isTitleLoading}
          titleKey={titleKey}
          text={title}
          actionButton={actionButton}
          t={t}
          dynamicClassForTitle={dynamicClassForTitle}
          />

        {children}
      </div>
    </div>
  );
};

function Title({ isLoading, titleKey, text, actionButton, t, dynamicClassForTitle="" }) {
  let innerContent = null;

  if (isLoading) {
    innerContent = (
      <div className="page-title-placeholder shimmer-animation"></div>
    );
  } else {
    innerContent = titleKey ? t(titleKey) : text;
  }

  let title = null;
  if (actionButton) {
    title = (
      <div className="page_title_margin_top page_title_margin_bottom d-flex flex-row justify-content-between align-items-center">
        {innerContent ? <h2 className={`page-title ${styles[dynamicClassForTitle]}`}>{innerContent}</h2> : null}
        {actionButton}
      </div>
    );
  } else {

    title = innerContent ? (
      <h2 className={`page-title page_title_margin_top page_title_margin_bottom ${styles[dynamicClassForTitle]} `}>
        {innerContent}
      </h2>
    ) : null;
  }

  return title;
}

export default withTranslation()(Page);
